import React from 'react';
import { Button, Container, Row, Col, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import resolvePublicAsset from '../utils/resolvePublicAsset';

function Home() {
  const banners = [
    {
      id: 1,
      name: 'Cultura em movimento',
      content: resolvePublicAsset('images/banner_01.jpeg')
    },
    {
      id: 2,
      name: 'Arte e território',
      content: resolvePublicAsset('images/banner_02.jpeg')
    },
    {
      id: 3,
      name: 'Redes e formação',
      content: resolvePublicAsset('images/banner_03.jpeg')
    }
  ];

  const atalhos = [
    {
      titulo: 'Sobre o instituto',
      descricao: 'Conheça a trajetória, a base comunitária e os princípios que orientam a atuação do Acesso Popular.',
      imagem: resolvePublicAsset('images/foto_equipe_acesso_popular.jpg'),
      to: '/quem-somos',
      acao: 'Ver página',
      exibirLogoCompleta: false
    },
    {
      titulo: 'Projetos em destaque',
      descricao: 'Acompanhe iniciativas culturais, circulação artística e espaços reservados para novas frentes.',
      imagem: resolvePublicAsset('images/circuitopaulistahiphop/2aedicao/porto_feliz/capa.png'),
      to: '/projetos',
      acao: 'Explorar projetos',
      exibirLogoCompleta: true
    },
    {
      titulo: 'Entre em contato',
      descricao: 'Abra um canal para propostas, parcerias, convites e mensagens sobre as ações do instituto.',
      imagem: resolvePublicAsset('images/semanahiphop/2017/galeria_01.jpg'),
      to: '/contato',
      acao: 'Falar com o Acesso Popular',
      exibirLogoCompleta: false
    }
  ];

  return (
    <div className="home-page">
      <section className="home-showcase-section mt-4">
        <Container>
          <Row className="g-4 align-items-stretch">
            <Col lg={12}>
              <div className="home-carousel-card">
                <Carousel indicators={false} controls={banners.length > 1} className="home-carousel">
                  {banners.map((element) => (
                    <Carousel.Item key={element.id || element.name}>
                      <div className="home-carousel-image-wrap">
                        <img src={element.content} alt={element.name} className="home-carousel-image" />
                        <div className="home-carousel-overlay">
                          <span>{element.name}</span>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="home-mosaic-section mt-4">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="home-mosaic-card tall">
                <img src={resolvePublicAsset('images/acesso_registro_rua.jpeg')} alt="Registro de rua" className="img-fluid" />
              </div>
            </Col>
            <Col lg={6}>
              <Row className="g-4">
                <Col xs={12}>
                  <div className="home-mosaic-card">
                    <img src={resolvePublicAsset('images/acesso_acontece.jpeg')} alt="Acontece no Acesso Popular" className="img-fluid" />
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="home-mosaic-card">
                    <img src={resolvePublicAsset('images/acesso_parceiros.jpeg')} alt="Parceiros do Acesso Popular" className="img-fluid" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="home-grid-section mt-4">
        <Container>
          <div className="home-section-heading">
            <span>Navegação rápida</span>
            <h3 className='mt-2'>Explore as principais áreas do site</h3>
          </div>
          <Row className="g-4 mb-5">
            {atalhos.map((atalho) => (
              <Col lg={4} md={6} key={atalho.titulo}>
                <div className="home-link-card">
                  <div className={`home-link-card-image`}>
                    <img src={atalho.imagem} alt={atalho.titulo} className="img-fluid" />
                  </div>
                  <div className="home-link-card-body">
                    <h3>{atalho.titulo}</h3>
                    <p>{atalho.descricao}</p>
                    <Button as={Link} to={atalho.to} variant="outline-dark" className="home-button-secondary w-100">
                      {atalho.acao}
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Home;